exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".toggle-span {\n    display: inline-block;\n    vertical-align: top;\n    margin-right: 5px;\n}\n\n.react-toggle {\n    display: inline-block;\n    vertical-align: top;\n}\n\n.custom-select {\n    width: 200px;\n}\n", ""]);

